
import React, { useState } from 'react';

export default function ContactForm() {
  const [status, setStatus] = useState(null);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState('');

  const validateFiles = (selectedFiles) => {
    if (selectedFiles.length > 5) return 'Du kan højst uploade 5 billeder.';
    if (selectedFiles.some((file) => file.size > 10 * 1024 * 1024)) {
      return 'Hver fil må højst fylde 10 MB. Vælg venligst mindre billeder.';
    }
    if (selectedFiles.reduce((total, file) => total + file.size, 0) > 20 * 1024 * 1024) {
      return 'Filerne må højst fylde 20 MB i alt. Vælg færre eller mindre billeder.';
    }
    return '';
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const error = validateFiles(selectedFiles);
    if (error) {
      setFileError(error);
      e.target.value = '';
      setFiles([]);
      return;
    }
    setFileError('');
    setFiles(selectedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;
    const selectedFiles = Array.from(formElement.elements.images.files);
    const error = validateFiles(selectedFiles);
    if (error) {
      setFileError(error);
      return;
    }

    const data = new FormData(formElement);

    try {
      const response = await fetch('/_api/webform/submit', {
        method: 'POST',
        body: data,
      });

      if (response.ok) {
        setStatus('success');
        formElement.reset();
        setFiles([]);
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Honeypot field */}
        <div className="sr-only absolute" aria-hidden="true">
          <label htmlFor="website_url">Website URL</label>
          <input type="text" id="website_url" name="website_url" tabIndex="-1" autoComplete="off" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Navn *"
              required
              className="w-full px-5 py-4 bg-gray-50 text-slate-900 border border-gray-200 placeholder-slate-400 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all text-lg"
            />
          </div>
          <div>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="E-mail *"
              required
              className="w-full px-5 py-4 bg-gray-50 text-slate-900 border border-gray-200 placeholder-slate-400 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all text-lg"
            />
          </div>
        </div>

        <div>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Telefon *"
            required
            className="w-full px-5 py-4 bg-gray-50 text-slate-900 border border-gray-200 placeholder-slate-400 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all text-lg"
          />
        </div>

        <div>
          <textarea
            id="message"
            name="message"
            rows="5"
            placeholder="Besked *"
            required
            className="w-full px-5 py-4 bg-gray-50 text-slate-900 border border-gray-200 placeholder-slate-400 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all text-lg resize-none"
          ></textarea>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2 ml-1">
            Upload billeder (Op til 5)
          </label>
          <div className="relative">
            <input
              type="file"
              id="images"
              name="images"
              multiple
              accept=".pdf,.png,.jpg,.jpeg,.gif,.webp"
              onChange={handleFileChange}
              className="sr-only"
            />
            <label
              htmlFor="images"
              className="flex items-center justify-between w-full px-5 py-4 bg-gray-50 text-slate-600 border border-gray-200 rounded-xl hover:border-orange-400 focus-within:ring-2 focus-within:ring-orange-500 cursor-pointer transition-all"
            >
              <span className="text-slate-400 text-lg">
                {files.length > 0 
                  ? `${files.length} ${files.length === 1 ? 'billede' : 'billeder'} valgt` 
                  : 'Vælg billeder...'}
              </span>
              <span className="bg-orange-50 text-orange-700 px-4 py-2 rounded-full text-sm font-semibold">
                Gennemse
              </span>
            </label>
          </div>
          {fileError && <p className="text-red-500 text-sm mt-2 ml-1">{fileError}</p>}
        </div>

        <button
          type="submit"
          className="w-full bg-[#ff6a00] hover:bg-[#e05d00] text-white font-bold py-5 px-8 rounded-full transition-colors duration-200 text-xl shadow-lg mt-4 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={!!fileError}
        >
          INDHENT TILBUD
        </button>

        {status === 'success' && (
          <p className="text-green-600 font-bold mt-4 text-lg bg-green-50 p-4 rounded-xl border border-green-100">Tak for din besked! Vi vender tilbage hurtigst muligt.</p>
        )}
        {status === 'error' && (
          <p className="text-red-600 font-bold mt-4 text-lg bg-red-50 p-4 rounded-xl border border-red-100">Der opstod en fejl. Prøv igen med færre eller mindre billeder, eller ring til os.</p>
        )}
      </form>
    </div>
  );
}
